import { Logo } from '@artic/ui/logo';
import { Spinner } from '@artic/ui/spinner';

/**
 * Branded full-screen splash shown while the app is booting — covers the
 * initial router load (`beforeLoad` / `getCurrentUser`) so a cold Cloud Run
 * backend doesn't leave the user staring at a blank white screen. Also used
 * as the `AuthProvider` Suspense fallback in `__root.tsx`.
 *
 * Not wired as a router-wide `defaultPendingComponent` — this is an
 * initial-load-only splash, not a per-navigation one.
 */
export function AppLoading() {
  return (
    <div className="flex h-screen w-full flex-col items-center justify-center gap-4">
      <Logo size="lg" />
      <Spinner className="text-muted-foreground" />
    </div>
  );
}
